export const DISPLAY_DATE_FORMAT = 'dd-MM-yyyy';
export const FORM_DATE_FORMAT = 'yyyy-MM-dd';
